import { animated, useSpring } from "@react-spring/web";
import { useState } from "react";

import { Row } from "@components/Flex";
import { useComponentVisible, useTheme, useWindowDimensions } from "@hooks";
import { ArrowDown } from "./ArrowDown";
import { ArrowUp } from "./ArrowUp";
import { styles } from "./styles";
import { BottomSliderProps } from "./types";

const DEFAULT_BOTTOM_SLIDER_OFFSET = 80;

export const BottomSlider = ({
  children,
  offset = DEFAULT_BOTTOM_SLIDER_OFFSET,
  height: heightProp,
}: BottomSliderProps) => {
  const { theme } = useTheme();

  const { height: windowHeight } = useWindowDimensions();
  const [isExpanded, setIsExpanded] = useState(false);

  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(true);

  const bottomSlideHeight = heightProp ?? windowHeight * 0.4;
  const show = isExpanded && isComponentVisible;

  const props = useSpring({
    top: show ? windowHeight - bottomSlideHeight : windowHeight - offset,
    left: 0,
    right: 0,
    position: "fixed",
    backgroundColor: theme.slider.background,
    height: bottomSlideHeight,
    width: "100vw",
    overflowY: show ? "scroll" : "hidden",
  });

  const toggle = () => {
    setIsComponentVisible(!isExpanded);
    setIsExpanded(!isExpanded);
    ref.current?.scrollTo(0, 0);
  };

  return (
    // @ts-expect-error: FIXME
    <animated.div ref={ref} style={props} onClick={toggle}>
      <Row style={styles.drawer}>
        <div style={styles.left}>{children}</div>
        <div style={styles.right}>{show ? <ArrowDown /> : <ArrowUp />}</div>
      </Row>
    </animated.div>
  );
};
